import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Grid, TextField } from '@mui/material';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';

dayjs.extend(utc);

export default function ManualPaidDialog({
  open,
  onClose,
  selectedDueDate,
  selectedDate,
  selectedTime,
  inputError,
  setSelectedDueDate,
  setSelectedTime,
  setInputError,
  handleConfirmBarCode,
  handleCancel
}) {
  const isToday = selectedDueDate && dayjs(selectedDueDate).isSame(dayjs(), 'day');
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <span>ยืนยันการรับชำระเงิน <PriceCheckIcon color='success'/> </span>
      </DialogTitle>
      <form
        onSubmit={e => {
          e.preventDefault();
          handleConfirmBarCode();
        }}
      >
        <DialogContent>
          <DialogContentText>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                <span style={{ fontSize: '0.8rem' }}>
                  วันที่รับชำระเงิน
                  <span style={{ color: 'red', fontSize: '1rem' }}>*</span>
                </span>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDueDate}
                    inputFormat="DD/MM/YYYY"
                    minDate={selectedDate}
                    maxDate={dayjs()}
                    onChange={(newValue) => {
                      setSelectedDueDate(newValue);
                      setInputError(prev => ({ ...prev, date: false }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: '100%' }}
                        error={inputError.date}
                        helperText={inputError.date ? 'กรุณาเลือกวันที่รับชำระเงิน' : ''}
                        id="invoice-due-date"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6} sx={{ mt: 1 }}>
                <span style={{ fontSize: '0.8rem' }}>
                  เวลาที่รับชำระเงิน
                  <span style={{ color: 'red', fontSize: '1rem' }}>*</span>
                </span>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    ampm={false}
                    maxTime={isToday ? dayjs() : null}
                    value={selectedTime}
                    onChange={(newValue) => {
                      setSelectedTime(newValue);
                      setInputError(prev => ({ ...prev, time: false }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: '100%' }}
                        id="invoice-time"
                        error={inputError.time || inputError.timeFuture}
                        helperText={inputError.timeFuture ? 'ไม่สามารถเลือกเวลาที่มากกว่า ณ ปัจจุบันได้' : inputError.time ? 'กรุณาเลือกเวลาที่รับชำระเงิน' : ''}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button type='submit'>ยืนยัน</Button>
          <Button color='error' onClick={handleCancel}>ยกเลิก</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}